import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import auth from './authReducer'
import app from './appReducer'
import teams from './teamReducer'
import company from './companyReducer'
import settings from './settingsReducer'
import contents from './contentReducer'
import templates from './templatesReducer'
import subscription from './subscriptionReducer'

const createRootReducer = (history) =>
  combineReducers({
    auth,
    app,
    teams,
    company,
    settings,
    contents,
    templates,
    subscription,
    router: connectRouter(history)
  })
export default createRootReducer
